"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGroupStyled = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const types_1 = require("../types");
exports.ButtonGroupStyled = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: ${({ align }) => align};
  gap: ${({ theme, spacing = types_1.buttonGroupSpacing.large }) => {
    const { buttonGroupSpacingSmall, buttonGroupSpacingLarge, marginLeftSmall, marginLeftLarge, marginBottomSmall, marginBottomLarge, } = theme;
    /**
     * @description Temporary fallback to support deprecated theme properties
     */
    const spacingVerticalSmall = marginBottomSmall || buttonGroupSpacingSmall;
    const spacingVerticalLarge = marginBottomLarge || buttonGroupSpacingLarge;
    const spacingHorizontalSmall = marginLeftSmall || buttonGroupSpacingSmall;
    const spacingHorizontalLarge = marginLeftLarge || buttonGroupSpacingLarge;
    switch (spacing) {
        case types_1.buttonGroupSpacing.small:
            return `${spacingVerticalSmall} ${spacingHorizontalSmall}`;
        case types_1.buttonGroupSpacing.large:
        default:
            return `${spacingVerticalLarge} ${spacingHorizontalLarge}`;
    }
}};
`;
